<template>
  <div id="page-login">
    <div class="xs-p-20 xs-fill-white">
      <div class="form-section box-section" style="display: none">
        <p class=" alert alert-warning text-center t14 cl-red " v-if="method && method == 'couponattach'">
          {{$t('login.coupon_message')}}</p>
        <strong>
          {{$t('login_noti_title')}}<br/>
        </strong>
        <div class="text-grey">
          <ul class="rule">
            <li>{{$t('login_content_1')}}</li>
            <li>{{$t('login_content_2')}}</li>
            <li>{{$t('login_content_3')}}</li>
          </ul>
        </div>
      </div>

      <div class="form-section">
        <form @submit="checkForm"
              action=""
              method="post"
              novalidate="true">

          <div class="form-section__heading"><span>{{$t('sign_in_out')}}</span></div>
          <div class="form-field">
            <div class="xs-flex xs-items-center xs-mb-5">
              <label class="label label-input xs-mb-0" for="emailAddress">{{$t('email')}}</label>
              <span v-if="errors.emailAddress" class="xs-text-right typo-l7 xs-text-red xs-ml-auto ">
                                <span>{{ errors.emailAddress }}</span>
                            </span>
            </div>
            <input id="emailAddress" ref="emailAddress" class="input xs-mb-10 "
                   v-bind:class="{ 'has-errors': errors.emailAddress }"
                   name="emailAddress" v-model="emailAddress"
                   value="" v-bind:placeholder="$t('local_holder_login_email')"
                   type="text"
                  @focus="eventSigninStart()"
            >
          </div>
          <div class="form-field">
            <div class="xs-flex xs-items-center xs-mb-5">
              <label class="label label-input xs-mb-0" for="password">{{$t('your_pass')}}</label>
              <span v-if="errors.password" class="xs-text-right typo-l7 xs-text-red xs-ml-auto ">
                                <span>{{ errors.password }}</span>
                            </span>
            </div>
            <input id="password" ref="password" class="input xs-mb-10 " v-bind:class="{ 'has-errors': errors.password }"
                   v-model="password" name="password" value="" v-bind:placeholder="$t('local_holder_login_password')"
                   type="password" required>
          </div>
          <router-link to="/getmypassword" class="forget-pass text-red t15 " style="text-decoration:none">
            {{$t('forgot_password')}}
          </router-link>
          <input type="submit" class="button button--primary" v-bind:value="$t('btn_sign_in')">
        </form>
      </div>
      <div class="form-section" v-if="!isLineLogin" @click="eventLoginByGoogle()">
        <div class="form-section__heading"><span>{{$t('sign_in_out_with')}}</span></div>
        <div class="md-flex">
          <!-- <fb-signin-button
            v-if="isShowFbLogin"
            :params="fbSignInParams"
            @success="onSignInFBSuccess"
            @error="onSignInFBError"
            class="login-fb btn btn-primary xs-full-width xs-mr-5">
            {{$t('sign_in_fb')}}
          </fb-signin-button> -->
          <g-signin-button v-if="googleSignInParams.client_id" 
            :params="googleSignInParams"
            @success="onSignInSuccess" 
            @error="onSignInError"
            class="login-gg btn btn-default p-10 xs-full-width xs-ml-5">
            <img src="../assets/images/icons/icon-google.svg" alt="Icon google" style="height: 16px;">
            <span>{{$t('sign_in_google')}}</span>
          </g-signin-button>
        </div>
      </div>
      <div class="form-section hidden-xs">
        <router-link :to="{ path: '/register', query: {line_uid: line_uid ? line_uid : ''} }" class="button button--primary">{{$t('btn_create_account')}}</router-link>
      </div>
      <div class="form-section visible-xs">
        <div class="form-section__heading hidden-sm hidden-xs"><span>{{$t('sign_in_remember')}}</span></div>
        <div class="form-section__heading hidden-md hidden-lg"><span>{{$t('dont_have_account')}}</span></div>
        <router-link :to="{ path: '/register', query: {line_uid: line_uid ? line_uid : ''} }" class="button button--primary">{{$t('btn_create_account')}}</router-link>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import GSignInButton from 'vue-google-signin-button'
  import FBSignInButton from 'vue-facebook-signin-button'

  Vue.use(FBSignInButton)
  Vue.use(GSignInButton)

  const ModalCompleteRegister = () => import('../components/popup/ModalCompleteRegister')

  export default {
    components: {
      Vue
    },
    props: {
      method: {
        type: String,
        required: false,
        default: ''
      }
    },
    computed: {},
    created() {
      const vm = this

      // Is redirected from LINE login, res from LINE: https://client.example.org/cb?code=abcd1234&state=0987poi&friendship_status_changed=true
      // @see: https://developers.line.biz/en/docs/line-login/integrate-line-login/#making-an-authorization-request
      // ***Note: NEED BOTH `code` & `state` to verify request from LINE (NOT from COUPON ATTACHMENT request)
      if (this._.has(this.$route.query, 'code') && this._.has(this.$route.query, 'state')) {
        this.isLineLogin = true
        vm.line_uid = vm.$route.query.code

        // get Access token
        this.getLineAccessToken()
      }

      if (this.$auth.check()) {
        if (this._.has(this.$route.params, 'login')
          && this.$route.params.login === this.$const.PROFILE_LOGIN
        ) {
          return this.$router.push({name: 'profile'})
        } else {
          return this.redirectToPage(this.$const.SLUG_LIST.DEAL)
        }
      }
    },
    mounted() {
      this.eventTrackingScreenLoad(this, {screen: {'name': 'account.login', 'type': 'account'}})
      this.ggData()
      this.fbData()

      this.isShowFbLogin = (this.$route.query.isShowFbLogin) ? true : false
    },
    beforeCreate() {
      window.fbAsyncInit = function ($fbId) {
        if ($fbId.app_id) {
          FB.init({
            appId: $fbId.app_id,
            cookie: true, // enable cookies to allow the server to access the session
            xfbml: true, // parse social plugins on this page
            version: 'v3.1' // use graph api version 2.8
          })
        }
      };
      (function (d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0]
        if (d.getElementById(id)) return
        js = d.createElement(s)
        js.id = id
        js.src = 'https://connect.facebook.net/en_US/sdk.js'
        js.rel = 'preconnect'
        fjs.parentNode.insertBefore(js, fjs)
      }(document, 'script', 'facebook-jssdk'))
    },
    beforeDestroy() {
      this.$root.$emit('closeModalCompleteRegister')
    },
    watch: {
      emailAddress: function (newValue, oldValue) {
        this.errors.emailAddress = ''
        if (!this.emailAddress) {
          this.errors.emailAddress = this.$t('required_display')
        } else if (!this.validEmailNotRFC(this.emailAddress)) {
          this.errors.emailAddress = this.$t('validate_invalid_email')
        }
      },
      password: function (newValue, oldValue) {
        this.errors.password = ''
        if (!this.password) {
          this.errors.password = this.$t('required_display')
        }
      }
    },
    data() {
      return {
        emailAddress: '',
        password: '',
        errors: {
          'emailAddress': '',
          'password': ''
        },
        googleSignInParams: {
          client_id: '',
          scope: 'email',
          plugin_name: `PHI Japan`
        },
        fbSignInParams: {
          scope: 'email',
          return_scopes: true
        },
        isShowFbLogin: false,
        line_info: {},
        line_uid: '',
        isLineLogin: false,
        app_secret: '',
        app_id: ''
      }
    },
    methods: {

      checkForm: function (e) {
        this.errors = {
          'emailAddress': '',
          'password': ''
        }
        let flag = false
        if (this.emailAddress && this.validEmailNotRFC(this.emailAddress) && this.password) {
          this.callbackLogin({email: this.emailAddress, password: this.password})
          e.preventDefault()
          return false
        }

        if (!this.emailAddress) {
          this.errors.emailAddress = this.$t('required_display')
          flag = true
          this.$refs.emailAddress.focus()
        } else if (!this.validEmailNotRFC(this.emailAddress)) {
          this.errors.emailAddress = this.$t('validate_invalid_email')
          flag = true
          this.$refs.emailAddress.focus()
        }

        if (!this.password) {
          this.errors.password = this.$t('required_display')
          if (!flag) {
            this.$refs.password.focus()
          }
        }

        e.preventDefault()
      },
      onSignInSuccess(googleUser) {
        const vm = this
        let profile = googleUser.getBasicProfile() // etc etc
        const data = {
          social_id: profile.getId(),
          social_type: this.$const.GOOGLE_LOGIN,
          email: profile.getEmail()
        }
        this.axios.apiCustomer.checkAccountBySocial(data, function (response) {
          let idToken = googleUser.getAuthResponse('id_token')
          const params = {
            social_id: profile.getId(),
            email: profile.getEmail(),
            first_name: profile.getFamilyName(),
            last_name: profile.getGivenName(),
            social: vm.$const.GOOGLE_LOGIN,
            social_token: idToken.id_token
          }
          vm.eventLoginByGoogleSuccess()
          if (response.data.data && response.data.data.check) {
            vm.callbackLogin(params)
          } else {
            vm.$modal.show(ModalCompleteRegister, {
              data: params
            }, {
              class: 'modal-complete-register',
              height: 'auto',
              transition: 'nice-modal-fade',
              overlayTransition: 'overlay-fade',
              clickToClose: false,
              name: 'modal-complete-register'
            })
          }
        }, (err) => {
          console.log('Error function onSignInSuccess', err)
        })
      },
      onSignInError(error) {
        this.$notify({
        	type: 'error',
        	title: 'Error',
        	text: 'Login google failed'
        })
      },
      onSignInFBSuccess(response) {
        let accessToken = response.authResponse.accessToken
        //let appsecret_proof = CryptoJS.HmacSHA256(accessToken, this.app_secret).toString(CryptoJS.enc.Hex);
        FB.api('/me', 'get', {fields: 'id,name,first_name,last_name,middle_name,gender,email,birthday,picture'}, dude => {
          if (typeof dude.email !== 'undefined') {
            let params = {
              social_id: dude.id,
              email: dude.email,
              first_name: dude.first_name,
              last_name: dude.last_name,
              social: this.$const.FACEBOOK_LOGIN,
              social_token: accessToken,
              //appsecret_proof: appsecret_proof
            }
            this.callbackLogin(params)
          } else {
            this.$router.push({'name': 'register'})
          }
        })
      },
      onSignInFBError(error) {
        this.$notify({
        	type: 'error',
        	title: 'Error',
        	text: 'Login facebook failed'
        })
      },
      callbackLogin: function (params) {
        let user = params;

        user.localFirstName = params.first_name;
        user.localLastName = params.last_name;

        var vm = this

        // LINE integration
        if (vm.line_uid !== '') {
          user.line_uid = vm.line_uid
        }

        this.$auth.login({
          data: user,
          rememberMe: true,
          success: function (response) {
            if (response.data.status) {
              // update cart
              vm.$cart.updateCartUuid(vm)
              vm.eventTrackingLoginSuccess(vm)

              if (vm.method && vm.$root.$route.query.callback && !vm.isLineLogin) {
                let query = vm.$root.$route.query
                let code = query.code
                // delete query['callback']
                // delete query['code']
                vm.$router.push({
                  name: 'coupon-attach',
                  params: {name: vm.$root.$route.query.name, code: code},
                  query: query
                })
              } else {
                if (this._.has(this.$route.params, 'login')
                  && this.$route.params.login === vm.$const.PROFILE_LOGIN
                ) {
                  vm.$router.push({name: 'profile'})
                } else {
                  if (vm.$route.query && vm.$route.query.hasOwnProperty('returnUrl')) {
                    vm.$router.push(vm.$route.query.returnUrl).catch(() => {
                      // fix bug Navigation cancelled when verify email register
                      console.log('Navigation Failure');
                      if (vm.$session.get('showCouponBanner') == 1) {
                        vm.$router.push('/order/coupons')
                      }
                    })
                  } else {
                    const outletCode = vm.$disposition.getByKey(vm, 'outletCode', '') || null
                    if (outletCode == null) {
                      const validatePass = response.data.data.item.validatePassword;
                      setTimeout(() => {
                        vm.$router.push({'name': 'home', 'params': {'validatePassword': validatePass}})
                      }, 500)
                    } else {
                      setTimeout(() => {
                        vm.redirectToPage(vm.$const.SLUG_LIST.DEAL)
                      }, 500)
                    }
                  }
                }
              }

            } else {
              this.errors.emailAddress = response.data.error.msg
            }
          },
          error: function (data) {
            // vm.$notify({
            // 	type: 'error',
            // 	title: 'Error',
            // 	text: 'Login failed. Please check it again!'
            // })
          }
        })
      },
      getLineAccessToken: function() {
        let vm = this

        const { code } = vm.$route.query

        const data = {
          grant_type: 'authorization_code',
          code,
          redirect_uri: `${window.location.hostname}${this.$route.fullPath}`,
          client_id: process.env.LINE_CHANNEL_ID,
          client_secret: process.env.LINE_CHANNEL_SECRET
        }
        vm.axios.apiCustomer.getLineAccessToken(data, res => {
          vm.line_info = res
        }, err => {
          console.log(`error: ${err}`)
        })
      },
      ggData: function () {
        let param = {scope: 'social.gg'}
        var vm = this
        this.axios.apiTenant.getSocialByClient(param, function (response) {
          vm.googleSignInParams.client_id = response.data.web
        }, function (error) {
          console.log(`error: ${error}`)
        })
        // this.axios.get('product-tenant/config?scope=social.gg')
        //   .then(respones => {
        //     this.googleSignInParams.client_id = respones.data
        //   }).catch(error => {
        //   console.log(error)
        // })
      },
      fbData: function () {
        var vm = this;
        let param = {scope: 'social.fb'}
        this.axios.apiTenant.getSocialByClient(param, function (response) {
          vm.app_secret = response.app_secret;

          window.fbAsyncInit(response.data);
        }, function (error) {
          console.log(`error: ${error}`)
        })
        // this.axios.get('product-tenant/config?scope=social.fb')
        //   .then(respones => {
        //     window.fbAsyncInit(respones.data)
        //   }).catch(error => {
        //   console.log(error)
        // })
      }
    }
  }
</script>

<style>
  .g-signin-button {
    /* This is where you control how the button looks. Be creative! */
    display: inline-block;
    padding: 4px 8px;
    border-radius: 3px;
    background-color: #3c82f7;
    color: #fff;
    box-shadow: 0 3px 0 #0f69ff;
  }

  .fb-signin-button {
    /* This is where you control how the button looks. Be creative! */
    display: inline-block;
    padding: 4px 8px;
    border-radius: 3px;
    background-color: #4267b2;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue